class CommentsForm {

  constructor() {

    if (!this.setVars())
      return

    //this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.commentsForm')

    if (!this.section)
      return

    this.form = this.section.querySelector('.commentsForm__form')

    return true

  }

  /*
  setEvents() {

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.form.reset();
      document.body.bindCustomEvent('open-popup', 'comment-added')
    })
  }
  */
}
